/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCreateUnit } from '../../factoriesAny.js';
export var createUnitDependencies = {
  UnitDependencies: UnitDependencies,
  typedDependencies: typedDependencies,
  createCreateUnit: createCreateUnit
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCreateUnit.generated.js
// module id = 1516
// module chunks = 0